export const sidebarColumns = {
  cols: 12,
  md: 5,
  lg: 4,
};
